const { ttq } = window;

export function enableTikTokTracking() {
  ttq && ttq.grantConsent();
}

export function disableTikTokTracking() {
  ttq && ttq.revokeConsent();
}

export function sendTikTokPageViewEvent(
  productId: string,
  productName: string,
  value: number,
  currency: string,
  productDescription: string
) {
  ttq &&
    ttq.track("ViewContent", {
      contents: [
        {
          content_id: productId,
          content_name: productName,
        },
      ],
      content_type: "product",
      description: productDescription,
      value,
      currency,
    });
}

export function sendTikTokAddToCartEvent(
  productId: string,
  productName: string,
  currency: string,
  productDescription: string,
  quantity: number,
  price: number
) {
  ttq &&
    ttq.track("AddToCart", {
      contents: [
        {
          content_id: productId,
          content_name: productName,
          quantity,
          price,
        },
      ],
      content_type: "product",
      description: productDescription,
      value: price * quantity,
      currency,
    });
}
